import * as Yup from "yup";

export const LEAVE_GROUP_TYPE = {
  LEAVE: "LEAVE_GROUP_01",
  OFFSITE_MEETING: "LEAVE_GROUP_02",
  OTHER: "LEAVE_GROUP_03",
};

export const REQUEST_CONDITION_TYPE = {
  ADVANCE_ONLY: "LEAVE_REQUEST_CONDITION_01",
  ALLOW_BACKDATE: "LEAVE_REQUEST_CONDITION_02",
  ALLOW_ADVANCE_AND_BACKDATE: "LEAVE_REQUEST_CONDITION_03",
};

export const initialValues = {
  leaveTypeName: null,
  leaveTypeNameEn: null,
  leaveGroup: null,
  leaveGroupId: null,
  description: null,
  maxLeaveAccum: null,
  minimumLeave: null,
  docLimitPerDay: 99,
  requestConditionId: '65b229fe23ce3526be36ff6f',
  requestConditionCode: "LEAVE_REQUEST_CONDITION_03",
  maxLeaveAccumLastYear: null,
  expiringMonth: null,
  gender: '65b22d5123ce3526be36ff73',
  leaveCalculation: '65b22f6e23ce3526be36ff77',
};

const LeaveTypeSchema = Yup.object().shape({
  leaveTypeName: Yup.string().required("Please enter."),
  leaveTypeNameEn: Yup.string().required("Please enter."),
  leaveGroupId: Yup.string().required("Please select."),
  description: Yup.string().required("Please enter."),

  minimumLeave: Yup.string().required("Please enter."),
  docLimitPerDay: Yup.string().required("Please enter."),
  requestConditionId: Yup.string().required("Please enter."),

});

export default LeaveTypeSchema;
